module.exports = __webpack_public_path__ + "static/media/yellow-gry.465db22e.png";